import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import { LoaderWithoutHeight } from "components/Loader";
import { GlobalDetailSectionCard } from "components/DesignSystem/sharedUiPatterns";
import {
  detailAccentPalette,
  RequestDetailField,
} from "components/DesignSystem/RequestDetailField";
import { dateFormat } from "services/constants";
import moment from "moment";

export const UserProfileDetails = ({ userId }) => {
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let current = true;
    setResult(null);
    const loadProfile = async () => {
      try {
        const response = await customGetAPI(`${domain}person/${userId}/`);
        if (current) {
          setResult({ userId, domain, token, data: response?.ok ? response.responseDetails : null });
        }
      } catch {
        if (current) setResult({ userId, domain, token, data: null });
      }
    };
    loadProfile();
    return () => { current = false; };
  }, [domain, token, userId, retry]);

  if (!result || result.userId !== userId || result.domain !== domain || result.token !== token) {
    return <LoaderWithoutHeight />;
  }
  if (!result.data) {
    return (
      <Mui.Alert severity="error" action={<Mui.Button onClick={() => setRetry((value) => value + 1)}>Retry</Mui.Button>}>
        Couldn't load this user's profile. Please try again.
      </Mui.Alert>
    );
  }

  const profile = result.data;
  const sections = [
    ["Personal Information", [
      ["Full Name", profile.full_name],
      ["Phone", profile.phone_number],
      ["Email", profile.email],
      ["Date of Birth", profile.birthday ? moment(profile.birthday).format(dateFormat) : null],
      ["Gender", profile.gender],
      ["Aadhaar", profile.aadhar],
      ["PAN", profile.pan],
      ["Address", profile.address],
    ]],
    ["Employment Information", [
      ["User Code", profile.user_code],
      ["Role", profile.role],
      ["Date of Joining", profile.date_of_join],
      ["Team", profile.team],
      ["Department Lead", profile.department_lead_name],
    ]],
  ];

  return (
    <Mui.Stack spacing={2}>
      {sections.map(([title, fields]) => (
        <GlobalDetailSectionCard key={title} title={title}>
          {fields.map(([label, value], index) => (
            <RequestDetailField
              key={label}
              icon={PersonOutlineOutlinedIcon}
              label={label}
              value={value || "N/A"}
              accent={detailAccentPalette.indigo}
              isLast={index === fields.length - 1}
            />
          ))}
        </GlobalDetailSectionCard>
      ))}
    </Mui.Stack>
  );
};
